import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createInvoice, updateInvoice, deleteInvoice, listInvoice } from '@/api/invoice.js';
import util from '@/libs/util.js';
import dayjs from 'dayjs';
export default {
  name: 'purchase-invoice-add',
  components: {},
  data: function data() {
    return {
      dialogTitle: '添加发票信息',
      dialogVisible: false,
      loading: false,
      form: {
        invoiceList: []
      },
      formRules: {
        invoiceNumber: [{
          required: true,
          message: '请输入发票号',
          trigger: ['blur', 'change']
        }]
      },
      purchaseOrderId: null,
      invoiceTypeList: [{
        ID: 1,
        name: '增值税普通发票'
      }, {
        ID: 2,
        name: '增值税专用发票'
      }, {
        ID: 3,
        name: '电子增值税普通发票'
      }, {
        ID: 4,
        name: '电子增值税专用发票'
      }],
      formLoading: false,
      uploadAction: process.env.VUE_APP_API + '/insideNew/upload',
      uploadToken: {},
      uploadFilePrefixURL: null
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(purchaseOrderId, invoiceList) {
      var that = this;
      that.dialogVisible = true;
      that.formLoading = false;
      that.purchaseOrderId = purchaseOrderId;
      that.uploadToken = {
        Authorization: util.cookies.get('token'),
        Os: 'web',
        PLATFORM: 'Web'
      };
      that.uploadFilePrefixURL = process.env.VUE_APP_OSS_URL + '/';

      if (invoiceList.length > 0) {
        that.form.invoiceList = JSON.parse(JSON.stringify(invoiceList));
      } else {
        that.loadInvoice();
      }
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
      that.$emit('confirm', that.form.invoiceList);
    },
    loadInvoice: function loadInvoice() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.form.invoiceList = [];

                if (!that.purchaseOrderId) {
                  _context.next = 7;
                  break;
                }

                that.loading = true;
                _context.next = 6;
                return listInvoice({
                  purchaseOrderId: that.purchaseOrderId,
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  res.list.forEach(function (row) {
                    row.attachment = row.attachment ? JSON.parse(row.attachment) : [];
                    row.invoiceType = row.invoiceType ? row.invoiceType : null; // row.taxAmount = (Number(row.money) * (Number(row.taxRate) / 100)).toFixed(2)
                    // row.amountIncludingTax = (Number(row.money) + row.taxAmount).toFixed(2)
                  });
                  that.form.invoiceList = res.list;
                }).catch(function (e) {});

              case 6:
                that.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    invoiceAddItem: function invoiceAddItem() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, item;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                item = {
                  ID: null,
                  amountIncludingTax: 0,
                  attachment: [],
                  invoiceCode: null,
                  invoiceNumber: null,
                  invoiceType: null,
                  invoicingDate: null,
                  money: 0,
                  purchaseOrderId: that.purchaseOrderId,
                  taxAmount: 0,
                  taxRate: 0,
                  validationCode: null
                };
                that.form.invoiceList.push(item);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    invoiceSaveItem: function invoiceSaveItem(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;

                if (row.invoicingDate) {
                  if (row.invoicingDate.length === 8) {
                    row.invoicingDate = row.invoicingDate.substr(0, 4) + '-' + row.invoicingDate.substr(4, 2) + '-' + row.invoicingDate.substr(6, 2);
                  }

                  row.invoicingDate = dayjs(row.invoicingDate).format('YYYY-MM-DD');
                }

                if (that.purchaseOrderId) {
                  form = JSON.parse(JSON.stringify(row));
                  delete form.ID;

                  if (!form.attachment) {
                    form.attachment = [];
                  }

                  form.attachment = JSON.stringify(form.attachment);
                  form.amountIncludingTax = Number(form.amountIncludingTax);
                  form.money = Number(Number(Number(form.amountIncludingTax) / Number(1 + Number(form.taxRate) / 100)).toFixed(2));
                  form.taxAmount = Number(Number(Number(form.amountIncludingTax) - Number(form.money)).toFixed(2));
                  form.invoiceType = form.invoiceType || 0;
                  form.taxRate = Number(form.taxRate);
                  row.taxAmount = Number(form.taxAmount);
                  row.money = Number(form.money);
                  row.amountIncludingTax = Number(form.amountIncludingTax);

                  if (row.ID) {
                    form.id = row.ID;

                    if (row.invoiceNumber) {
                      updateInvoice(form).then().catch(function (e) {});
                    }
                  } else {
                    if (row.invoiceNumber) {
                      createInvoice(form).then(function (res) {
                        row.ID = res.ID;
                      }).catch(function (e) {});
                    }
                  }
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    invoiceDeleteItem: function invoiceDeleteItem(row) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, findIdx;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                findIdx = that.form.invoiceList.indexOf(row);
                that.form.invoiceList.splice(findIdx, 1);

                if (row.ID) {
                  deleteInvoice({
                    id: row.ID
                  }).then(function (res) {}).catch(function () {});
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    handleRemove: function handleRemove(file, fileList, row) {
      console.log(file, fileList);
      var that = this;
      row.attachment.forEach(function (item, idx) {
        console.log('item', item);

        if (item === file) {
          console.log(file);
          row.attachment.splice(idx, 1);
          that.invoiceSaveItem(row);
        }
      });
    },
    handlePreview: function handlePreview(file) {
      var that = this;
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = that.uploadFilePrefixURL + file.url;
      link.setAttribute('download', file.name);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
    uploadSuccess: function uploadSuccess(res, file, fileList, row) {
      var that = this;
      row.attachment.push({
        url: file.response.data.file.url,
        name: file.response.data.file.name,
        uid: file.response.data.file.uid,
        status: file.response.data.file.status
      });
      that.invoiceSaveItem(row);
    },
    isImage: function isImage(url) {
      var ext = url.substr(-4).toLowerCase();

      if (ext === '.jpg' || ext === '.png' || ext === 'jpeg') {
        return true;
      } else {
        return false;
      }
    },
    formSubmit: function formSubmit() {
      var that = this;
      that.$refs.form.validate(function (valid, err) {
        if (valid) {
          that.$emit('confirm', that.form.invoiceList);
          that.dialogClose();
        } else {
          for (var key in err) {
            that.$message.error(err[key][0].message);
            return;
          }
        }
      });
    },
    showDatePicker: function showDatePicker(refName) {
      var that = this;
      that.$nextTick(function () {
        setTimeout(function () {
          // that.$refs[refName].focus()
          document.getElementById(refName).focus();
        });
      });
    }
  }
};